import axios from 'axios';
export default {
	init(amount) {
		return axios.get('/apps/composite/api/creditcard/installment/init', { params: { amount } });
	},
	calculate(data) {
		return axios.post('/apps/composite/api/creditcard/installment/calculate', data);
	}
};
